// extracted by mini-css-extract-plugin
module.exports = {"boxesList":"BoxesList_boxesList__5e24A"};